import { ButtonProps, Space } from 'antd';
import { replace } from 'lodash/fp';
import React, { FC } from 'react';
import Clock from 'react-live-clock';

import { useTimezone } from '../../../../components/TimezoneProvider';
import HeaderButton from '../Button';

const TimezoneButton: FC<ButtonProps> = (props) => {
  const timezone = useTimezone();

  return (
    <HeaderButton disabled {...props}>
      <span>
        <Space size={4}>
          <Clock format="HH:mm" ticking timezone={timezone} />
          <span>{replace('_', ' ', timezone)}</span>
        </Space>
      </span>
    </HeaderButton>
  );
};

TimezoneButton.displayName = 'TimezoneButton';

export default TimezoneButton;
